import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m15.696 14.286-4.808-4.807a6 6 0 1 0-1.41 1.41l4.808 4.807a.997.997 0 1 0 1.41-1.41m-9.678-4.28a3.988 3.988 0 1 1 0-7.976 3.988 3.988 0 0 1 0 7.976" }));
const ForwardRef = forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
